<template>
  <i 
    class="iconfont" 
    :class="[iconClass, className]"
    :style="{ fontSize: size, color: color }"
    :title="title"
  ></i>
</template>

<script>
export default {
  name: 'IconFont',
  props: {
    // 图标名称
    name: {
      type: String,
      required: true
    },
    // 图标大小
    size: {
      type: String,
      default: '16px'
    },
    // 图标颜色
    color: {
      type: String,
      default: 'currentColor'
    },
    // 自定义类名
    className: {
      type: String,
      default: ''
    },
    // 提示文本
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass() {
      return `icon-${this.name}`
    }
  }
}
</script>

<style lang="scss" scoped>
.iconfont {
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  
  // 禁用用户选择
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  
  // 平滑过渡效果
  transition: transform 0.2s ease, color 0.2s ease;
  
  // 旋转动画
  &.spin {
    animation: spin 1s linear infinite;
  }
  
  // 脉冲动画
  &.pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  
  // 弹跳动画
  &.bounce {
    animation: bounce 1s infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
</style>